<div class="card">
  <div class="header">
    <span>Firearm Acquisition</span>
    @if (nextValidationFields.length) {
      <div class="next-validation-alert" role="alert">
        <i class="fa-solid fa-circle-exclamation"></i>
        <span class="next-validation-label">Please fill in:</span>
        <div class="next-validation-fields">
          @for (field of nextValidationFields; track field) {
            <span class="next-validation-field">{{ field }}</span>
          }
        </div>
        <button type="button" class="next-validation-dismiss" (click)="nextValidationFields = []" aria-label="Dismiss validation message">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    }
    <button type="button" class="close-btn" (click)="openHome()" title="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="card-body">
    <mat-horizontal-stepper [linear]="true" #stepper (selectionChange)="onStepSelectionChange()">
      <!-- Custom icon for 'edit' state -->
      <ng-template matStepperIcon="edit">
        <mat-icon>check_circle</mat-icon>
      </ng-template>
      <!-- Custom icon for 'done' state -->
      <ng-template matStepperIcon="done">
        <mat-icon>check_circle</mat-icon>
      </ng-template>
      <mat-step label="Firearm Details">
        <!-- Step 1 content goes here -->
      </mat-step>
      <mat-step label="Received From">
        <!-- Step 2 content goes here -->
      </mat-step>
      <mat-step label="Acquisition Review">
        <!-- Step 3 content goes here -->
      </mat-step>
      <mat-step label="Acquisition Completed">
        <!-- Step 4 content goes here -->
      </mat-step>
    </mat-horizontal-stepper>
    <!-- <app-step-progress-bar></app-step-progress-bar> -->
    <hr class="divider" />
    <form [formGroup]="acquisition_form">
      <div class="background-img acquisition-form-content">
        <div class="row m-0">
          <!-- Required Fields -->
          @if (stepper.selectedIndex <= 1) { <div>
            <span class="required" style="font-weight: 500; margin-left: 20px">*</span>
            <span style="color: white"> Denotes a required field</span>
        </div>
        }
        <!-- Left side Step 1 -->
        @if (stepper.selectedIndex === 0) {
        <div class="col-6 left_side firearm-details-panel">
          <!--Firearm UPC-->
          <div class="form_input">
            <label class="control-label label top-label" for="firearm_upc" style="display: inline-block">
              Firearm UPC:
            </label>
            <!-- <div class="form-group"> -->
            <input type="text" class="form-control text-uppercase input top-input" formControlName="firearm_upc"
              id="firearm_upc" tooltip="{{ acquisition_form.get('firearm_upc').value }}" placement="right"
              style="display: inline-block" (input)="enableNextBtn(); findThisFirearm()" />
            <i class="fa-solid fa-barcode icon_inside_input" style="color: black"></i>
            <!-- </div> -->
          </div>
          <!--Firearm Type-->
          <div class="form_input">
            <label class="control-label label" for="firearm_type" style="display: inline-block">
              <span class="required">*</span> Firearm Type:
            </label>
            <ng-select [items]="firearm_types" [multiple]="false" [closeOnSelect]="true" appendTo="body"
              class="form-control text-uppercase input" formControlName="firearm_type" id="firearm_type"
              style="display: inline-block" (input)="enableNextBtn()" (change)="
                    enableNextBtn();
                    getCaliberList();
                    getManufactureList();
                    clearDependentFirearmFields([
                      'manufacture',
                      'model',
                      'caliber_gauge',
                    ])
                  "></ng-select>
          </div>
          <!--Serial Number-->
          <div class="form_input">
            <label class="control-label label" for="serial_number" style="display: inline-block">
              <span class="required">*</span> Serial Number:
            </label>
            <div class="form-group">
              <input #serial_number type="text" class="form-control text-uppercase input blackout"
                formControlName="serial_number" id="serial_number" style="display: inline-block; color: black"
                [style.background-color]="serial_editing_blackout" (blur)="compareSerialInputs()"
                (input)="enableNextBtn()" />
              @if (
              acquisition_form.value.serial_number ===
              acquisition_form.value.serial_number2 &&
              acquisition_form.value.serial_number &&
              acquisition_form.value.serial_number2
              ) {
              <i class="fa-solid fa-circle-check icon-inside-input2" style="color: green"></i>
              }
              @if (
              acquisition_form.value.serial_number !==
              acquisition_form.value.serial_number2 &&
              acquisition_form.value.serial_number &&
              acquisition_form.value.serial_number2
              ) {
              <i class="fa-solid fa-circle-xmark icon-inside-input2" style="color: red"></i>
              }
            </div>
          </div>
          <!--Serial2 Number-->
          <div class="form_input">
            <label class="control-label label" for="serial_number2" style="display: inline-block">
              <span class="required">*</span> Serial Number:
            </label>
            <div class="form-group">
              <input type="text" class="form-control text-uppercase input" formControlName="serial_number2"
                id="serial_number2" style="display: inline-block" (focus)="serialEdit()" (blur)="compareSerialInputs()"
                (input)="enableNextBtn()" />
              @if (
              acquisition_form.value.serial_number ===
              acquisition_form.value.serial_number2 &&
              acquisition_form.value.serial_number &&
              acquisition_form.value.serial_number2
              ) {
              <i class="fa-solid fa-circle-check icon-inside-input2" style="color: green"></i>
              }
              @if (
              acquisition_form.value.serial_number !==
              acquisition_form.value.serial_number2 &&
              acquisition_form.value.serial_number &&
              acquisition_form.value.serial_number2
              ) {
              <i class="fa-solid fa-circle-xmark icon-inside-input2" style="color: red"></i>
              }
            </div>
          </div>
          <!--Manufacture-->
          <div class="form_input">
            <label class="control-label label" for="manufacture" style="display: inline-block">
              <span class="required">*</span> Manufacture:
            </label>
            <ng-select [items]="sharedService.distinct_manufacture_list" [addTag]="true" [multiple]="false"
              [closeOnSelect]="true" appendTo="body" class="form-control text-uppercase input"
              formControlName="manufacture" id="manufacture" style="display: inline-block" (change)="
                    enableNextBtn();
                    getManufactureModels();
                    getCaliberList();
                    clearDependentFirearmFields(['model', 'caliber_gauge'])
                  "></ng-select>
          </div>
          <!--Importer-->
          <div class="form_input">
            <label class="control-label label" for="importer" style="display: inline-block">
              Importer:
            </label>
            <input type="text" class="form-control text-uppercase input" formControlName="importer" id="importer"
              tooltip="{{ acquisition_form.get('importer').value }}" placement="right" style="display: inline-block" />
          </div>
          <!--Model-->
          <div class="form_input">
            <label class="control-label label" for="model" style="display: inline-block">
              <span class="required">*</span> Model:
            </label>
            <ng-select [items]="distinct_model_list" [addTag]="true" [multiple]="false" [closeOnSelect]="true"
              appendTo="body" class="form-control text-uppercase input" formControlName="model" id="model"
              style="display: inline-block" (change)="
                    enableNextBtn();
                    getCaliberList();
                    clearDependentFirearmFields(['caliber_gauge'])
                  "></ng-select>
          </div>
          <!--Additional Markings-->
          <div class="form_input">
            <label class="control-label label" for="additional_markings" style="display: inline-block">
              Additional Markings:
            </label>
            <input type="text" class="form-control text-uppercase input" formControlName="additional_markings"
              id="additional_markings" tooltip="{{
                    acquisition_form.get('additional_markings').value
                  }}" placement="right" style="display: inline-block" />
          </div>
          <!--Caliber / Gauge-->
          <div class="form_input">
            <label class="control-label label" for="caliber_gauge" style="display: inline-block">
              <span class="required">*</span> Caliber / Gauge:
            </label>
            <ng-select [items]="distinct_firearm_calibers" [addTag]="true" [multiple]="false" [closeOnSelect]="true"
              appendTo="body" class="form-control text-uppercase input" formControlName="caliber_gauge"
              id="caliber_gauge" style="display: inline-block" (change)="enableNextBtn()"></ng-select>
          </div>
          <div class="acquisition-actions">
            <div class="acquisition-action-row">
              <span class="next-button-wrapper" (click)="showNextValidation()">
                <button type="button" class="btn grey-btn btn-sm acquisition-action-primary" style="min-width: 140px;"
                  (click)="$event.stopPropagation(); nextStepClick()" [disabled]="disableNextBtn">
                  Next
                </button>
              </span>
            </div>
          </div>
        </div>
        }
        <!-- Left side Step 2 -->
        @if (stepper.selectedIndex === 1) {
        <div class="col-6 left_side received-from-panel">
          <!--FFL Number-->
          <div class="form_input mb-3">
            <label class="control-label label mb-0" for="ffl">FFL:</label>
            <div class="d-flex align-items-center gap-2 w-100">
              <input type="text" class="form-control text-uppercase input" formControlName="ffl" id="ffl"
                style="width: 150px; margin: 0;" [placeholder]="'_-__-___-__-__-_____'" [dropSpecialCharacters]="false"
                mask="0-00-000-00-0A-00000" (input)="fetchFfl()" />
              <button type="button" class="btn grey-btn btn-sm"
                style="white-space: nowrap; height: 38px; min-width: 100px; margin: 0;" (click)="fflSearchClick()">
                FFL Search
              </button>
            </div>
          </div>
          <!--Received From Name-->
          <div class="form_input">
            <label class="control-label label" for="received_from_name" style="display: inline-block"><span
                class="required">*</span> Received From Name:</label>
            <input #received_from_name type="text" class="form-control text-uppercase input"
              formControlName="received_from_name" id="received_from_name" tooltip="{{
                    acquisition_form.get('received_from_name').value
                  }}" placement="right" style="display: inline-block" (input)="enableNextBtn()" />
          </div>
          <!--Business Name-->
          <div class="form_input">
            <label class="control-label label" for="business_name" style="display: inline-block">
              Business Name:
            </label>
            <input type="text" class="form-control text-uppercase input" formControlName="business_name"
              id="business_name" tooltip="{{ acquisition_form.get('business_name').value }}" placement="right"
              style="display: inline-block" [style.background-color]="serial_editing_blackout" />
          </div>
          <!--Address-->
          <div class="form_input">
            <label class="control-label label" for="address" style="display: inline-block">
              Address:
            </label>
            <input type="text" class="form-control text-uppercase input" formControlName="address" id="address"
              tooltip="{{ acquisition_form.get('address').value }}" placement="right" style="display: inline-block" />
          </div>
          <!--Address2-->
          <div class="form_input">
            <label class="control-label label" for="address2" style="display: inline-block">
              Address 2:
            </label>
            <input type="text" class="form-control text-uppercase input" formControlName="address2" id="address2"
              tooltip="{{ acquisition_form.get('address2').value }}" placement="right" style="display: inline-block" />
          </div>
          <!--Zip Code-->
          <div class="form_input">
            <label class="control-label label" for="zip_code" style="display: inline-block">
              Zip Code:
            </label>
            <input type="text" class="form-control text-uppercase input" formControlName="zip_code" id="zip_code"
              style="display: inline-block" (input)="findStateAndCity()" />
          </div>
          <!--State-->
          <div class="form_input">
            <label class="control-label label" for="state" style="display: inline-block">
              State:
            </label>
            <input type="text" class="form-control text-uppercase input" formControlName="state" id="state"
              style="display: inline-block" />
          </div>
          <!--City-->
          <div class="form_input">
            <label class="control-label label" for="city" style="display: inline-block">
              City:
            </label>
            <ng-select [items]="distinct_cities" [addTag]="true" [multiple]="false" [closeOnSelect]="true"
              appendTo="body" class="form-control text-uppercase input" formControlName="city" id="city"
              style="display: inline-block"></ng-select>
          </div>
          <!--Date Acquired-->
          <div class="form_input">
            <label class="control-label label" for="date_acquired" style="display: inline-block">
              <span class="required">*</span> Date Acquired:
            </label>
            <input #date_acquired type="text" class="form-control text-uppercase input" formControlName="date_acquired"
              id="date_acquired" style="display: inline-block" placeholder="__/__/__ __:__" [bsConfig]="bsConfig"
              [(bsValue)]="today" [readOnly]="false" bsDatepicker (input)="enableNextBtn()" />
          </div>
          <div class="acquisition-actions">
            <div class="acquisition-action-row">
              <button type="button" class="btn grey-btn progression_btn btn-sm acquisition-action-secondary"
                (click)="previousStepClick()">
                <i class="fa-solid fa-left-long"></i> Previous Step
              </button>
              <span class="next-button-wrapper" (click)="showNextValidation()">
                <button type="button" class="btn grey-btn btn-sm acquisition-action-primary" style="min-width: 140px;"
                  (click)="$event.stopPropagation(); nextStepClick()" [disabled]="disableNextBtn">
                  Next
                </button>
              </span>
            </div>
          </div>
        </div>
        }
        <!-- Left side Step 3 -->
        @if (stepper.selectedIndex === 2) {
        <div class="col-6 left_side acquisition-review-panel">
          <!-- Please Review-->
          <div class="row review-header-row">
            <span class="review-notice" style="color: white !important">Please review all information before adding to your bound book.</span>
          </div>
          <!-- Type -->
          <div class="form_input2">
            <div class="step3_title">
              <span>Type:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form.get("firearm_type")?.value?.toUpperCase()
                }}</span>
            </div>
          </div>
          <!-- Serial Number -->
          <div class="form_input2">
            <div class="step3_title">
              <span>Serial Number:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form.get("serial_number")?.value?.toUpperCase()
                }}</span>
            </div>
          </div>
          <!-- Manufacture -->
          <div class="form_input2">
            <div class="step3_title">
              <span>Manufacture:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form.get("manufacture")?.value?.toUpperCase()
                }}</span>
            </div>
          </div>
          <!-- Importer -->
          <div class="form_input2">
            <div class="step3_title">
              <span>Importer:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form.get("importer")?.value?.toUpperCase()
                }}</span>
            </div>
          </div>
          <!-- Model -->
          <div class="form_input2">
            <div class="step3_title">
              <span>Model:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form.get("model")?.value?.toUpperCase()
                }}</span>
            </div>
          </div>
          <!-- Additional Markings -->
          <div class="form_input2">
            <div class="step3_title">
              <span>Additional Markings:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form
                .get("additional_markings")
                ?.value?.toUpperCase()
                }}</span>
            </div>
          </div>
          <!-- Caliber / Gauge -->
          <div class="form_input2">
            <div class="step3_title">
              <span>Caliber:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form.get("caliber_gauge")?.value?.toUpperCase()
                }}</span>
            </div>
          </div>
          <!-- Acquired Date -->
          <div class="form_input2">
            <div class="step3_title">
              <span>Acquired Date:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form.get("date_acquired").value
                | date: "longDate"
                }}</span>
            </div>
          </div>
          <!-- Acquired From -->
          <div class="form_input2 acquired-from-row">
            <div class="step3_title">
              <span>Acquired From:</span>
            </div>
            <div class="step3_value">
              <span>{{
                acquisition_form.get("ffl").value
                }}</span>
              <span>{{
                acquisition_form.get("received_from_name").value
                }}</span>
              <span>{{
                acquisition_form.get("business_name").value
                }}</span>
            </div>
          </div>
          <!--Notes-->
          <div class="review-notes-row">
            <label class="control-label note-label" for="notes">Optional Notes:
            </label>
            <textarea #notes class="form-control note-input" formControlName="notes"></textarea>
          </div>
          <div class="acquisition-actions review-actions">
            <div class="acquisition-action-row">
              <button type="button" class="btn grey-btn progression_btn btn-sm acquisition-action-secondary"
                (click)="previousStepClick()">
                <i class="fa-solid fa-left-long"></i> Previous Step
              </button>
              <button type="button"
                class="btn btn-sm green-btn progression_btn acquisition-action-primary acquisition-submit-btn"
                (click)="submitAcquisitionClick()">
                Submit Acquisition
              </button>
            </div>
          </div>
        </div>
        }
        <!-- Left side Step 4 -->
        @if (stepper.selectedIndex === 3) {
        <div class="col-12 left_side_step_4">
          <!--Reset Acquisition Form-->
          @if (stepper.selectedIndex === 3) {
          <button class="btn grey-btn stage_4_btn float-end" (click)="resetAcquisitionFormClick()">
            Reset Acquisition Form
          </button>
          }
          <!--Reset Acquisition Form-->
          @if (stepper.selectedIndex === 3) {
          <button class="btn blue-btn stage_4_btn float-end" (click)="repeatAcquisitionClick()">
            Repeat Acquisition
          </button>
          }
          <!--Close-->
          @if (stepper.selectedIndex === 3) {
          <button class="btn red-btn stage_4_btn float-end" (click)="closeClick()">
            Close
          </button>
          }
        </div>
        }
        <!-- Right side Step 1-2 class="col-6 right_side right_col_bg-img"-->
        @if (stepper.selectedIndex === 1) {
        <div class="col-6 right_side">
          @if (stepper.selectedIndex === 1) {
          <div class="right_step_2 firearm-info-summary">
            <h2 class="firearm-info-summary-title">
              Firearm Information
            </h2>
            <dl class="firearm-info-grid">
              <div>
                <dt>UPC</dt>
                <dd>{{ acquisition_form.get("firearm_upc").value }}</dd>
              </div>
              <div>
                <dt>Type</dt>
                <dd>{{ acquisition_form.get("firearm_type").value }}</dd>
              </div>
              <div>
                <dt>Serial #</dt>
                <dd>{{ acquisition_form.get("serial_number").value }}</dd>
              </div>
              <div class="firearm-info-manufacturer">
                <dt>Manufacturer</dt>
                <dd>{{ acquisition_form.get("manufacture").value }}</dd>
              </div>
              <div>
                <dt>Importer</dt>
                <dd>{{ acquisition_form.get("importer").value }}</dd>
              </div>
              <div>
                <dt>Model</dt>
                <dd>{{ acquisition_form.get("model").value }}</dd>
              </div>
              <div class="firearm-info-caliber">
                <dt>Caliber / Gauge</dt>
                <dd>{{ acquisition_form.get("caliber_gauge").value }}</dd>
              </div>
            </dl>
          </div>
          }
        </div>
        }
      </div>
      <!---------------------------------------------------------------------------------------------------------------------->
  </div>
  </form>
</div>
</div>